import React from 'react';
import { Button } from 'primereact/button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './App.css';
import PageMain from './views/PageMain/PageMain';

function App() {
  return (
    <div className="h-full w-full">
     <PageMain />
 
     
    </div>
  );
}

export default App;
